import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';

import { StringUtil } from '../utils/string.util';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[forcedLineBreak]' })
/**
 * This directive is for forcing the word break on a smarter behavior
 * please see StringUtil.splitStringByPattern() for more information
 */
export class ForcedLineBreakDirective implements OnChanges, OnInit {
	@Input() public forcedLineBreak: string;
	@Input() public maxCharsPerLine: number = 14;
	@Input() public useInlineFlex: boolean = true;
	constructor(private elementRef: ElementRef, private renderer: Renderer2) { }
	private hardLimitOfChars: number = 56;

	public ngOnChanges(): void {
		this.resetView();
		this.initEmbeddedView();
	}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	public ngOnInit(): void {
		// Resolves LifeCycle error where ngOnInit is invoked
		// TypeError: directive.ngOnInit is not a function
	}

	private resetView(): void {
		const childElements = this.elementRef.nativeElement.childNodes;
		if (childElements.length) {
			for (let i = childElements.length - 1; i >= 0; i--) {
				this.renderer.removeChild(this.elementRef.nativeElement, childElements[i]);
			}
		}
	}
	private initEmbeddedView(): void {
		if (this.forcedLineBreak) {
			const parts = StringUtil.splitStringByPattern(this.forcedLineBreak, this.maxCharsPerLine, this.hardLimitOfChars);
			parts.forEach(part => {
				const child: HTMLSpanElement = document.createElement('span');
				child.innerHTML = part;
				this.renderer.appendChild(this.elementRef.nativeElement, child);
			});
			this.renderer.setStyle(this.elementRef.nativeElement, 'white-space', 'pre-wrap');
			this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this.forcedLineBreak);
			if (this.useInlineFlex) {
				this.renderer.addClass(this.elementRef.nativeElement, 'display-inline-flex');
			}
		}
	}
}
